module.exports = __webpack_public_path__ + "static/media/adult-dark-skin-tone-svgrepo-com.9c2c0bd5.svg";